import React, { createContext, useContext, ReactNode } from 'react';
import { useImageCache } from '../hooks/useImageCache';

interface ImageCacheContextType {
  getCacheBustedUrl: (url: string) => string;
  refreshImage: (imageUrlOrKey: string) => void;
  refreshImages: (imageUrlsOrKeys: string[]) => void;
  clearAllCache: () => void;
  imageReloadKeys: {[key: string]: number};
}

const ImageCacheContext = createContext<ImageCacheContextType | undefined>(undefined);

interface ImageCacheProviderProps {
  children: ReactNode;
}

export const ImageCacheProvider: React.FC<ImageCacheProviderProps> = ({ children }) => {
  const imageCache = useImageCache();

  return (
    <ImageCacheContext.Provider value={imageCache}>
      {children}
    </ImageCacheContext.Provider>
  );
};

export const useImageCacheContext = (): ImageCacheContextType => {
  const context = useContext(ImageCacheContext);
  if (context === undefined) {
    throw new Error('useImageCacheContext must be used within an ImageCacheProvider');
  }
  return context;
}; 